import { handleError } from '@/src/utils/handle-error'
import { registryWithContentSchema } from '@/src/utils/registry/schema'
import { HttpsProxyAgent } from 'https-proxy-agent'
import fetch from 'node-fetch'
import { createWriteStream } from 'fs'

const baseUrl = process.env.EXTERNAL_REGISTRY_URL ?? 'https://v0.dev'
const agent = process.env.https_proxy
  ? new HttpsProxyAgent(process.env.https_proxy)
  : undefined

export async function getComponentsFromExternalRegistry(
  ids: string[],
  token?: string
) {
  try {
    const result = await fetchExternalRegistry(ids, token)

    return registryWithContentSchema.parse(result)
  } catch (error) {
    handleError(error)
  }
}

async function fetchExternalRegistry(ids: string[], token?: string) {
  try {
    const results = await Promise.all(
      ids.map(async id => {
        const url = new URL(`${baseUrl}/api/r/${id}`)

        if (token) {
          url.searchParams.set('token', token)
        }

        const response = await fetch(url, {
          agent,
        })

        if (response.status === 404) {
          throw new Error(`Component ${id} not found.`)
        }

        if (response.status === 401) {
          if (token) {
            throw new Error(
              `Token is expired or invalid. Visit https://v0.dev/t/${id} to get a new one.`
            )
          }

          throw new Error(
            `This is a private component. Visit https://v0.dev/t/${id} to get a CLI token.`
          )
        }

        if (response.status === 200) return await response.json()

        throw new Error(
          `Failed to fetch component ${id}. ${response.statusText}`
        )
      })
    )

    return results
  } catch (error) {
    handleError(error)
  }
}

export async function downloadImageFromRegistry(
  url: string,
  destination: string
) {
  const imageUrl = new URL(`${baseUrl}${url}`)
  const fileStream = createWriteStream(destination, { flags: 'w' })
  const response = await fetch(imageUrl.toString())

  if (!response.body) {
    throw new Error(`Failed to download image from ${imageUrl}`)
  }

  await response.body.pipe(fileStream)
}
